export const SIDEBAR_WIDTH = 414;
